"use client";

import { getFilterValue, parseFilter } from "@shared/utils";
import { ComboboxOption, RadioGroup, RadioGroupItem } from "@ubud-ui/react-ui-kit";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";

const FILTER_KEY = "marital";

export function MaritalFilter({ path }: { path: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const options: ComboboxOption[] = [
    { value: "20", label: "Single / Belum Menikah" },
    { value: "10", label: "Sudah Menikah" },
  ];

  const handleFilter = (option: ComboboxOption) => {
    const paramsString = searchParams.toString();

    const value = {
      id: option.value,
      label: option.label,
    };

    const params = parseFilter(FILTER_KEY, value, qs.parse(paramsString));

    router.push(`${path}?${qs.stringify(params, { skipNulls: true })}`, {
      scroll: false,
    });
  };

  const getValue = (value?: string) => {
    const params = qs.parse(searchParams.toString());

    return getFilterValue(params, FILTER_KEY, value);
  };

  return (
    <>
      {options && options.length > 0 ? (
        <RadioGroup
          defaultValue={getValue()?.id}
          onValueChange={(value) => handleFilter(options.find((it) => it.value == value) as ComboboxOption)}
        >
          <div className="space-y-3 pb-2">
            {options.map((option, index) => {
              return (
                <div className="flex items-start gap-3" key={"marital-" + option.value + "-" + index}>
                  <RadioGroupItem className="mt-1" id={"marital-" + option.value + "-" + index} value={option.value.toString()} />
                  <label htmlFor={"marital-" + option.value + "-" + index}>{option.label}</label>
                </div>
              );
            })}
          </div>
        </RadioGroup>
      ) : (
        <div className="text-center font-bold pb-2">Status pernikahan tidak ditemukan</div>
      )}
    </>
  );
}
